import { Link } from 'react-router';
import { connect } from "react-redux";

var ReadingActions = require("lib/actions/ReadingActions");
var ReadingSelectors = require("lib/selectors/ReadingSelectors");

var DateSpanSelector = require("components/data/DateSpanSelector");
var CurrentUser = require('lib/account/CurrentUser');

var ParentInfoModal = require("components/users/parents/ParentInfoModal");
var ParentLogsApprovalModal = require("components/users/parents/ParentLogsApprovalModal");

var Spinner = require('components/utility/Spinner');
var DisplayToggleControl = require("components/utility/DisplayToggleControl");

var StudentAvatar = require("components/avatars/StudentAvatar");
var StudentMetrics = require("lib/data/StudentMetrics");
var StudentProgressDisplay = require("components/users/students/StudentProgressDisplay");
var RosterActions = require("lib/actions/RosterActions");
var RosterSelectors = require("lib/selectors/RosterSelectors");

var ProgressDisplay = require('components/users/students/ProgressDisplay');
var LogCalendar = require('components/reading/logs/LogCalendar');
var AllMonthsLogTable = require('components/reading/logs/AllMonthsLogTable');
var StudentExpectationsDisplay = require('components/users/students/StudentExpectationsDisplay');

require('users/parents/parent_page.scss');
require("users/students/student_progress_display.scss");

@connect(
	(state, props) => {
		var parent = RosterSelectors.parent({ state, id: props.match.params.id })
		if (parent) {
			var studentID = parent.children[0];
			var student = RosterSelectors.student({ state, id: studentID })
		}
		return { 
			logs: ReadingSelectors.logs({ state }),
			isLoadingLogs: ReadingSelectors.isLoadingLogs({ state }),
			parent: parent,
			student: student
		}
	},
	(dispatch, props) => {
		function populateLogs(userID) {
			return dispatch(ReadingActions.fetchLogs({ conditions: { userID: userID }}))
		}
		function fetchStudentData(startDate, endDate, studentID) {
			var embeds = [
				"student.expectations_date_spans", "student.expectations_progress",
				"student.avatar", "student.prefs"
			];
			var query = {};
			if (startDate) {
				query.expectations_progress_start_date = startDate;
			}
			if (endDate) {
				query.expectations_progress_end_date = endDate;
			}
			return dispatch(RosterActions.fetchStudent({
				id: studentID, query,
				embeds: embeds
			}))
		}
		return {
			fetchStudent: fetchStudentData,
			fetchParent: (parentID) => {
				return dispatch(RosterActions.fetchParent({ id: parentID, embeds: ["parent.children"] })).then((response) => {
					var studentID = response.students[0].id
					populateLogs(studentID);
					fetchStudentData(undefined, undefined, studentID);
				})
			}
		}
	}
)

class ParentPage extends React.Component {
	constructor(props) {
		super();
		autobind(this);
		this.state = { parent: null, currentView: "student-reports" };
	}

	onViewChange(view) {
		this.setState({ currentView: view });
	}

	startDate() {
		var dateSpans = this.props.student.expectations_date_spans;
		return this.state.startDate || dateSpans[0].start
	}
	endDate() {
		var dateSpans = this.props.student.expectations_date_spans;
		return this.state.endDate || dateSpans[0].end
	}

	changeDates(startDate, endDate) {
		this.setState({ startDate, endDate }, () => {
			this.props.fetchStudent(startDate, endDate, this.props.student.id)
		});
	}

	isMatchingDateSpan() {
		if (this.props.student && this.props.student.expectations_date_spans) {
			return _.filter(this.props.student.expectations_date_spans, (span) => {
				return (span.start == this.startDate()) && (span.end == this.endDate());
			}).length > 0;
		}
		return false
	}

	renderDateSelectors() {
		if (this.props.student && this.props.student.expectations_date_spans) {
			var dateSpans = this.props.student.expectations_date_spans;
			return (
				<div className="dateSpanSelectorWrap">
					<DateSpanSelector startDate={ this.startDate() } endDate={ this.endDate() }
						expectationsSpans={ dateSpans }
						onSelectDates={ this.changeDates } />
				</div>
			);			
		}
	}

	renderStudentSection() {
		// var student = this.getStudentData();

		// var studentReports = (
		// 	<div className="row">
		// 		<div className="col-sm-12 parentContentContainer">
		// 			<StudentExpectationsDisplay studentID={ student.id } />
		// 		</div>
		// 	</div>
		// );
		// return (
		// 	<div>
		// 		<header className="pageHeader">
		// 			<h1>{ parent.children[0].first_name }'s Progress Reports</h1>
		// 		</header>
		// 		{ studentReports }
		// 	</div>
		// )
		var student = this.props.student;
		var parent = this.props.parent;

		var grade_level = student && student.grade_level ? parseInt(student.grade_level) : 5
		var expectations = student.prefs.grade_level_expectations_metrics[grade_level]
		var progress = student.expectations_progress;
		expectations = _.sortBy(expectations, (expectation) => {
			if (expectation.metric == StudentMetrics.TYPES.QUIZZES_PASSED) {
				return "AAA"
			} else {
				return expectation.metric;
			}
		})
		if ((expectations || []).length) {
			var progressDisplay = _.map(expectations, (expectation, index) => {
				var metric = expectation.metric;
				if (progress) {
					var current = progress[metric];
				} else {
					var current = 0;
				}
				return (
					<StudentProgressDisplay
						key={ index }
						metric={ metric }
						title={ StudentMetrics.getLabel(metric) }
						unit={ StudentMetrics.getUnit(metric) }
						total={ expectation.goal }
						current={ current }
						actionLabel={ StudentMetrics.getActionLabel(metric) }
						hideButton={ true } />
				);
			});
		}
		return (
			<div>
				<header className="pageHeader">
					<h1>{ student.first_name }'s Learning Progress</h1>
				</header>
				<StudentAvatar student={ this.props.student } maxWidth={ 170 } />
				<div className="dashboardContainer">
					{ progressDisplay }
					{ this.renderDateSelectors() }
				</div>
			</div>
		)

	}

	afterLogUpdate(newData, removeLog) {
		var newDataID = newData.id;

		var newLogsData = _.compact(_.map(this.props.logs, function(log) {
			if (log.id != newDataID) {
				return log;
			} else if (!removeLog) {
				return newData;
			}
		}));

		this.setState({ logs: newLogsData });
	}

	afterLogVerification(logIDs) {
		var studentID = this.getStudentData().id;
		this.props.populateLogs(studentID)
		
		setTimeout(function() {
			window.wrNotifications.triggerDropDownNotification({
				title: "Reading Approved", text: "Thank you for signing off.", icon: "ok-circle"
			}, 2000)}, 500);
	}

	getStudentData() {
		return this.props.student;
	}

	getParentID() {
		return this.props.match.params.id;
	}
	getParentToken() {
		return $wr.getURLParameterByName("token");
	}

	logsRequireVerification() {
		var unverifiedLogs = _.select(this.props.logs, function(log) {
			return !log.verified;
		});

		return (unverifiedLogs.length > 0)
	}

	renderReadingSection() {
		if (this.props.isLoadingLogs) {
			return (
				<div><Spinner placeholder={ true } scale={ 1.7 } /></div>
			);
		}

		return (
			<div className="readingLogsSection">
				<header className="pageHeader">
					<h1>{ this.props.student.first_name }'s Reading Logs</h1>
				</header>
				<LogCalendar logs={ this.props.logs } />
				<AllMonthsLogTable logs={ this.props.logs } onUpdateLog={ this.afterLogUpdate } hideCommentBox={ true } />
			</div>
		)
	}

	checkVerifiedLogs() {
		var verifyIDs = $wr.getURLParameterByName("verify_ids");
        if (verifyIDs != null) {
            var logIDs = _.map(verifyIDs.split(","), parseInt);

            var params = { log: { verified: true }, update_ids: logIDs }
            CurrentUser.api().patchLog(logIDs[0], params, $wr.apiHandler(function(response) {
                // No action needed
            }));
            this.afterLogVerification(logIDs);
		}
	}

	render() {
		// filler for now, to demonstrate that we have updating parent data here
		if (this.props.parent) {
			var parentInfo = (
				<div>
					<p>
						Parent ID: { this.props.parent.id }
					</p>
					<p>
						Parent First Name: { this.props.parent.first_name }
					</p>
					<p>
						Parent Last Name: { this.props.parent.last_name }
					</p>
				</div>
			);

		 	var toggleOptions = [{ key: "student-reports", text: "Reports" }, 
		 		{ key: "reading-history", text: "Reading" }];

		 	var toggleDisplay = (
				<DisplayToggleControl options={ toggleOptions }
					onChange={ this.onViewChange }
					activeOptionKey={ this.state.currentView } />
			)
	
			if (this.state.currentView == "student-reports") {
				if (this.props.student.prefs) {
					var pageContent = this.renderStudentSection();
				}
			} else {
				var pageContent = this.renderReadingSection();
			}

			if (this.props.parent.not_accepted_terms) {
				var parentInfoModal = (
					<ParentInfoModal ref="modal" parentID={ this.getParentID() } 
						parentToken={ this.getParentToken() } onUpdateSuccess={ this.fetchParent } />
				)	
			}

			if (!this.props.isLoadingLogs && this.logsRequireVerification()) {
				var unverifiedLogs = _.select(this.props.logs, function(log) {
					return !log.verified;
				});
				var parentLogsApprovalModal = (
					<ParentLogsApprovalModal student={ this.props.parent.children[0] }
						logs={ unverifiedLogs } onUpdateLog={ this.afterLogUpdate }
						onLogVerification={ this.afterLogVerification } />
				);
			}
		}
		
		return (
			<div className="container" id="parentPage">
				{ toggleDisplay }			
				{ pageContent }

				{ parentLogsApprovalModal }
				{ parentInfoModal }		
			</div>
		);
	}

	componentDidMount() {
		CurrentUser.initTokenUser(this.getParentID(), this.getParentToken(), function(success) {
			$(document).trigger("current-user-updated");
			this.props.fetchParent(this.getParentID());
		}.bind(this));
	}
}

ParentPage.WrappedComponent.propTypes = PageStrictPropTypes({
	logs: PropTypes.array.isRequired,
	isLoadingLogs: PropTypes.bool,
	populateLogs: PropTypes.func,
	parent: PropTypes.object,
	student: PropTypes.object,
	fetchParent: PropTypes.func,
	fetchStudent: PropTypes.func,
	hideCommentBox: PropTypes.bool
});


module.exports = ParentPage; 


// WEBPACK FOOTER //
// ./modules/components/users/parents/ParentPage.js